/**
 * @generated SignedSource<<8a33f7ac998ae0847240391660f2392a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarkThreadAsReadInput = {
  threadId: string;
};
export type ChatChannelMainThreadMutation$variables = {
  input: MarkThreadAsReadInput;
};
export type ChatChannelMainThreadMutation$data = {
  readonly response: {
    readonly threadMember: {
      readonly id: string;
      readonly readAt: string | null;
    } | null;
  };
};
export type ChatChannelMainThreadMutation = {
  response: ChatChannelMainThreadMutation$data;
  variables: ChatChannelMainThreadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkThreadAsReadResponse",
    "kind": "LinkedField",
    "name": "markThreadAsRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ThreadMember",
        "kind": "LinkedField",
        "name": "threadMember",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "readAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatChannelMainThreadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatChannelMainThreadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cd74e74fa1f0917e72d3a0dd060dbf92",
    "id": null,
    "metadata": {},
    "name": "ChatChannelMainThreadMutation",
    "operationKind": "mutation",
    "text": "mutation ChatChannelMainThreadMutation(\n  $input: MarkThreadAsReadInput!\n) {\n  response: markThreadAsRead(input: $input) {\n    threadMember {\n      id\n      readAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a7c9dceda7991d9605bac6aed841491b";

export default node;
